import { render, staticRenderFns } from "./BasePhoneNumber.vue?vue&type=template&id=4e1d6290&scoped=true"
import script from "./BasePhoneNumber.vue?vue&type=script&lang=js"
export * from "./BasePhoneNumber.vue?vue&type=script&lang=js"
import style0 from "./BasePhoneNumber.vue?vue&type=style&index=0&id=4e1d6290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d6290",
  null
  
)

export default component.exports